import axios from "axios";
import config from "./config.json";
import { auth, saveLoggedInSession } from "../firebase";

const env = process.env.REACT_APP_ENV;

console.log("API URL:", {
  baseURL: config[env].baseURL,
  env,
});

const instance = axios.create({
  baseURL: config[env].baseURL,
});

// Global promise to track Firebase initialization
let firebaseReady = new Promise((resolve) => {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (user) {
      try {
        const token = await user.getIdToken();
        saveLoggedInSession(true); // Optional: Store token
        resolve(token);
      } catch (error) {
        console.error("Failed to fetch token during init:", error);
        resolve(null); // Continue without a token
      }
    } else {
      console.warn("User not authenticated.");
      resolve(null); // No user
    }
    unsubscribe(); // Cleanup listener
  });
});

// Helper to fetch token
const getToken = async () => {
  const user = auth.currentUser;
  if (!user) return null;
  return await user.getIdToken(false); // Use cached token unless forced refresh is needed
};

// Request Interceptor
instance.interceptors.request.use(
  async (config) => {
    // Wait for Firebase initialization to complete
    await firebaseReady;

    // Fetch token for the current user
    const token = await getToken();
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
